import styled from 'styled-components';

const MyHomeAspirationsStyles = styled.article`
  position: relative;

  .DXTextInput-note {
    text-align: left;
    color: #ef4b5d;
    font-size: 12px;
  }
  .container {
    max-width: 1138px;
    padding: 0px 40px;
    margin: 0 auto;
    @media screen and (max-width: 1099px) {
      padding: 0px 20px;
    }
  }
  /* 
  .grid-container {
    position: relative;
    max-width: 1138px;
    padding: 0px 40px;
    margin: 0 auto;
    height: 100%;
    @media screen and (max-width: 1099px) {
      padding: 0px 20px;
    }
  } */

  //// Hero //////
  .DXHero {
    position: relative;
    @media screen and (min-width: 901px) {
      padding: 80px 0px;
    }
    @media screen and (max-width: 900px) {
      padding: 45px 0px;
    }
    .DXHero-backdrop {
      max-height: 70%;
      @media screen and (min-width: 900px) {
        max-height: none !important;
      }
    }
    .DXHero-container {
      max-width: 1138px;
      padding: 0px 40px;
      margin: 0 auto;
      @media screen and (max-width: 1099px) {
        padding: 0px 20px;
        width: 100%;
        max-width: 670px;
      }
      @media screen and (max-width: 900px) {
        width: 100%;
        max-width: 100%;
      }
      .DXIconCard {
        max-width: 685px;
      }

      .DXIconCard {
        position: relative;

        .DXIconCard-content {
          h1,
          h2,
          p {
            font-family: 'source-sans-pro';
          }
          h1 {
            font-weight: 600;
            font-size: 40px;
            line-height: 48px;
            margin: 0px 0px 10px 0px !important;
            font-family: 'source-sans-pro';
            @media screen and (max-width: 1099px) {
              font-weight: 600;
              font-size: 32px;
              line-height: 38px;
              letter-spacing: -0.35px;
            }
          }
          p {
            font-size: 18px;
            line-height: 29px;
            color: #4e5255;
          }
        }
        .DXIconCard-icon {
          @media screen and (min-width: 1100px) {
            top: -25px;
          }
          @media screen and (min-width: 900px) {
            top: -35px;
          }
        }
      }
    }
  }

  //// Planner ///
  .planner-section {
    position: relative;
    padding: 40px 0px;
    .planner-box {
      background: white;
      padding: 60px 30px 30px;
      border: 0px solid transparent;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
    }
    .PlannerQuestion-heading {
      font-weight: 600;
      font-size: 25px;
      line-height: 33px;
      letter-spacing: -0.35px;
      color: #25292d;
      font-family: 'source-sans-pro';
      margin-bottom: 20px;
      max-width: 740px;
      margin: 0 auto;
    }
    .PlannerQuestion-note {
      font-size: 18px;
      line-height: 29px;
      color: #4e5255;
      max-width: 490px;
      margin: 20px auto 40px;
    }
    .PlannerQuestion-radio,
    .PlannerQuestion-input {
      font-family: 'source-sans-pro';
      &:hover {
        border: solid 1px #b9b9b9;
      }
      &:focus-visible {
        border: solid 1px #0075c9;
        background: rgb(0, 117, 201, 0.1);
      }
      p {
        padding: 20px;
      }
    }
    .PlannerQuestion-radio.active,
    .PlannerQuestion-input.active {
      border: solid 1px #0075c9;
    }
    .selectbox-wrap {
      position: relative;
      display: flex;
      gap: 50px;
      max-width: 400px;
      margin: 30px auto 5px;
      justify-content: center;

      @media screen and (max-width: 600px) {
        /* flex-wrap: wrap; */
        gap: 15px;
        .DXTextInput {
          width: 100px;
        }
      }
      .DXTextInput-label {
        top: 11px;
      }
      /* input {
        font-family: 'source-sans-pro';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 27px;
        color: #4e5255;
      } */
      .DXTextInput-input {
        font-family: 'source-sans-pro', sans-serif;
        font-size: 16px;
        font-weight: normal;
        /* line-height: 1.69; */
        letter-spacing: normal;
        color: #4e5255;
        border: 1px solid #e4e5e7;
        border-radius: 5px;
        /* height: 60px; */
        &:focus {
          border: solid 1px #0075c9;
          background: rgb(0, 117, 201, 0.1);
        }
      }
    }
  }

  //// Left Heading Section ////
  .left-heading-section {
    position: relative;
    padding: 40px 0px 40px;
    .left-heading-component {
      display: flex;

      @media screen and (max-width: 700px) {
        flex-direction: column;
        align-items: flex-start;
      }

      .left-side {
        flex: 0 0 200px;
        border-top: 1px solid #e4e5e7;
        @media screen and (max-width: 700px) {
          flex: 1 1 100%;
        }
        .left-heading {
          font-family: 'source-sans-pro';
          font-weight: 600;
          font-size: 18px;
          line-height: 24px;
          letter-spacing: -0.3px;
          color: #25292d;
          margin-top: 22px;
          @media screen and (max-width: 700px) {
            margin-bottom: 10px;
          }
        }
      }
      .right-side {
        flex: 1 1 1fr;
        padding-left: 20px;
        @media screen and (max-width: 700px) {
          padding-left: 0px;
          flex: 1 1 100%;
        }
      }
    }
  }

  .select-box-question {
    .PlannerQuestion-heading {
      font-size: 18px;
      line-height: 29px;
      color: #4e5255;
      max-width: 710px;
      margin: 0 auto;
      font-weight: 200;
    }
    .PlannerQuestion-note {
      font-weight: 600;
      font-size: 25px;
      line-height: 33px;
      letter-spacing: -0.35px;
      color: #25292d;
      font-family: 'source-sans-pro';
      max-width: 470px;
      margin: 20px auto 20px;
    }
  }
  #planAheadSection {
    &:after {
      @media screen and (max-width: 700px) {
        background: #ffc50a;
        height: 30%;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        z-index: 1;
        content: '';
        position: absolute;
      }
    }
  }

  .left-heading-section {
    position: relative;
    z-index: 2;

    .left-side {
      @media screen and (max-width: 700px) {
        border-top: 0px solid transparent !important;
        margin-bottom: 20px;
      }
    }
    .quad-columns {
      display: flex;
      flex-wrap: wrap;
      .quad-column {
        padding: 15px;
        flex: 1 1 50%;
        @media screen and (max-width: 700px) {
          margin-bottom: 40px !important;
        }
        p {
          ul {
            list-style-position: inside;
          }
        }
        .small-p {
          font-size: 12px;
          line-height: 16px;
          margin-top: 10px;
          max-width: 290px;
          a,
          span {
            color: inherit;
            font-family: inherit;
            font-size: inherit;
            display: flex;
          }
          a {
            margin-bottom: 7px;
          }
        }
        .quad-logo-wrap {
          position: relative;
          display: flex;
          margin-bottom: 12px;
          img {
            max-width: 240px;
          }

          /* .quad-logo-builtsmart {
            transform: translateX(-50px);
          }
          .quad-logo-designsmart {
            transform: translateX(-38px);
          }
          .quad-logo-energysmart {
            transform: translateX(-20);
          }
          .quad-logo-budgetsmart {
            transform: translateX(-20);
          } */
        }
        @media screen and (max-width: 700px) {
          flex: 1 1 100%;
          padding: 0px;
          margin-bottom: 25px;

          /* .quad-heading-wrap {
            display: flex;
            align-items: center;
            gap: 15px;
            border-bottom: 1px solid #e4e5e7;
            padding-bottom: 7px;
            margin-bottom: 15px;
            .quad-img {
              width: 37px;
              height: 37px;
              background: #e2f7ff;
              border: 0px solid transparent;
              border-radius: 8px;
              display: flex;
              position: relative;
              align-items: center;
              justify-content: center;
              img {
                max-width: 23px;
                max-height: 26px;
              }
            }
          } */
        }
        .quad-heading {
          font-weight: 600;
          font-size: 16px;
          line-height: 20px;
          letter-spacing: -0.3px;
          color: #25292d;
          display: flex;
          margin-top: 7px;
          margin-bottom: 4px;
        }
      }
    }
  }

  .recommendations-section {
    position: relative;
    padding: 40px 0px;
    border-bottom: 1px solid #e4e5e7;

    .DXItemsGrid {
      .DXItemsGrid-grid {
        @media screen and (max-width: 700px) {
          flex-direction: column;
          align-items: flex-start;
        }
      }
      .DXItemsGrid-heading {
        margin-bottom: 10px;
      }
      button {
        font-weight: 700;
        font-size: 12px;
        line-height: 12px;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        color: #4e5255;
        outline: 1.5px solid #e4e5e7;
        padding: 0px;
        height: auto;
        span {
          display: flex;
          font-family: 'source-sans-pro';
          font-style: normal;
          font-weight: 700;
          font-size: 12px;
          line-height: 12px;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          color: #4e5255;
          align-items: center;
          justify-content: center;
          padding: 9px 14px;
          height: auto;
          img {
            height: 15px;
            width: 15px;
            margin-right: 7px;
          }
        }
      }
    }
  }

  //// Recommended Homes ////

  .recommended-homes-section {
    position: relative;
    padding: 60px 0px 0px;
    .DXItemsGrid {
      position: relative;
      margin-bottom: 60px;
      .DXItemsGrid-heading {
        font-weight: 600;
        font-size: 25px;
        line-height: 30px;
        letter-spacing: -0.35px;
        color: #25292d;
        margin-bottom: 5px;
      }
      .DXItemsGrid-subheading {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #4e5255;
        margin-bottom: 12px;
      }
    }
    .DXItemsGrid-grid {
      gap: 0px;
      margin: auto -10px;
      .DXTooltip-content {
        left: -90px;
      }
    }
  }

  //// Accordion ////
  .accordion {
    position: relative;
    h3 {
      font-weight: 600;
      font-size: 25px;
      line-height: 30px;
      letter-spacing: -0.35px;
      color: #25292d;
      font-family: 'source-sans-pro';
    }
    .accordion-item {
      border-bottom: 1px solid #e4e5e7;
    }
  }

  .explore-section {
    position: relative;
    padding: 40px 0px 140px;
    .DXChip {
      font-weight: 600;
      font-size: 12px;
      line-height: 12px;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      color: rgba(37, 41, 45, 0.5);
    }
    .DXItemsGrid-heading {
      font-weight: 600;
      font-size: 25px;
      line-height: 30px;
      letter-spacing: -0.35px;
      color: #25292d;
      font-family: 'source-sans-pro';
    }
    .NextStepCard {
      max-width: 519px;
      border: 1px solid #e4e5e7;
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      .NextStepCard-link {
        -webkit-text-decoration: none;
        text-decoration: none;
        border-radius: 2px;
        outline: none;
        display: grid;
        grid-auto-flow: column;
        grid-column-gap: 0.5em;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;

        cursor: pointer;
        -webkit-transition: all 0.4s ease-in-out;
        transition: all 0.4s ease-in-out;
        color: currentColor;
        background: none;
        border: none;
        padding-left: 0;
      }
    }
  }

  .FeaturesGrid-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)) !important;
    position: relative;
    .features-loading-screen {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100%;
      width: 100%;
      z-index: 3;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.5);
    }
  }
  .view-more-features-wrap {
    position: relative;
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    .show-btn {
      color: #0075c9;
      border: 1px solid #e4e5e7 !important;
      font-family: 'source-sans-pro';
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      padding: 12px 12px;
      outline: none;
      text-transform: none;
      img {
        width: 12px;
      }
    }
    .show-btn.activated {
      img {
        transform: rotate(-180deg);
      }
    }
  }

  .featured-selections-mobile {
    position: relative;
    margin-top: 60px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    p.headline {
      font-family: 'source-sans-pro';
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 12px;
      text-align: justify;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      color: #4e5255;
    }
    .featured-selections-mobile-grid {
      width: 300px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
  }

  .edit-features-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 74px;
    font-family: 'source-sans-pro';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #0075c9;
    gap: 5px;
    border: 1px solid #e4e5e7 !important;
    outline: none;
    svg {
      width: 20px;
      height: 20px;
    }
  }
  .FeatureCard-label {
    line-height: 19px;
  }
  .FeatureCard.disabled {
    cursor: not-allowed;
    p {
      color: #d9d9d9;
    }
    .FeatureCard-icon {
      opacity: 0.2;
    }
    svg {
      opacity: 0.3;
    }
  }

  .FeaturesGrid-btn {
    display: none;
  }
  .FeaturesGrid-mobileNav {
    margin-top: 20px !important;
  }
`;

export default MyHomeAspirationsStyles;
